import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { LicitacaoAudesp } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LicitacaoAudespService } from '../../service/licitacao-audesp.service';

@Component({
  selector: 'lib-licitacao-audesp-pagamento-list',
  templateUrl: './licitacao-audesp-pagamento-list.component.html'
})
export class LicitacaoAudespPagamentoListComponent implements OnChanges, OnDestroy {

  @Input() public licitacao: number;
  @Input() public registroPreco: number;
  @Input() public ajuste: number;
  public listaPagamento: LicitacaoAudesp[];

  protected unsubscribe: Subject<void> = new Subject();

  constructor(private audespService: LicitacaoAudespService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ajuste) {
      this.audespService.filtrar(0, 0, { parente_id: this.ajuste, tipo: 'PAGAMENTO' }).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.listaPagamento = res?.content ? res.content : [];
          this.listaPagamento.forEach(item => item.identificacao = item.identificacao.replace(', ', '<br>'))
        })
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
